import LinkedInIcon from '@mui/icons-material/LinkedIn';
import GitHubIcon from '@mui/icons-material/GitHub';

export const SidebarLinks = [
    {
        title: "linkedin",
        icon: <LinkedInIcon/>,
        link: "https://www.linkedin.com/in/dev-matheus-santos/"
    },
    {
        title: "About",
        icon: <GitHubIcon/>,
        link: "https://github.com/web-Matheus"
    },
    
]
 